export const GET_USER_GAME_STATISTIC = "GET_USER_GAME_STATISTIC";
export const GET_USER_GAMES = "GET_USER_GAMES";
export const RESET_USER_GAMES = "RESET_USER_GAMES";
export const TOTAL_PAGES_USER_GAME_STATISTIC = "TOTAL_PAGES_USER_GAME_STATISTIC";
export const PAGINATION_PARAMS_USER_GAME_STATISTIC = "PAGINATION_PARAMS_USER_GAME_STATISTIC";
export const COUNT_USER_GAME_STATISTIC = "COUNT_USER_GAME_STATISTIC";
